(function () {
  function initAceiiTrainingGoals() {
    document.querySelectorAll('[data-aceii-training-goals]').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var desktopButtons = Array.prototype.slice.call(section.querySelectorAll('.acd-nav-item'));
      var accordionItems = Array.prototype.slice.call(section.querySelectorAll('.acd-acc-item'));
      var figures = Array.prototype.slice.call(section.querySelectorAll('[data-goal-media]'));
      var stage = section.querySelector('[data-goal-stage]');
      var stageHome = section.querySelector('[data-goal-stage-home]');
      var activeGoal = desktopButtons.length
        ? desktopButtons[0].getAttribute('data-goal')
        : accordionItems.length
          ? accordionItems[0].getAttribute('data-goal')
          : '';
      var sectionVisible = false;

      if (!stage || !activeGoal) return;

      function isMobile() {
        return window.matchMedia('(max-width: 760px)').matches;
      }

      function syncPoster(video) {
        var host = video && video.closest('[data-responsive-video-poster]');
        if (!host) return;
        var poster = isMobile()
          ? host.dataset.mobilePoster || host.dataset.poster || ''
          : host.dataset.poster || '';
        if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
      }

      function loadVideo(video) {
        if (!video) return;
        var changed = false;
        syncPoster(video);
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
          if (source.dataset.src && !source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
            changed = true;
          }
        });
        if (changed || video.readyState === 0) video.load();
      }

      function playActiveVideo() {
        if (!sectionVisible || document.hidden) return;
        var activeFigure = figures.filter(function (figure) {
          return figure.getAttribute('data-goal-media') === activeGoal;
        })[0];
        var video = activeFigure && activeFigure.querySelector('video');
        if (!video) return;
        loadVideo(video);
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      }

      function pauseInactiveVideos() {
        figures.forEach(function (figure) {
          var video = figure.querySelector('video');
          if (!video || figure.getAttribute('data-goal-media') === activeGoal) return;
          video.pause();
          try { video.currentTime = 0; } catch (error) {}
        });
      }

      function placeStage() {
        if (isMobile()) {
          var slot = section.querySelector('[data-goal-stage-slot="' + activeGoal + '"]');
          if (slot && stage.parentNode !== slot) slot.appendChild(stage);
        } else if (stageHome && stageHome.parentNode && stage.previousElementSibling !== stageHome) {
          stageHome.parentNode.insertBefore(stage, stageHome.nextSibling);
        }
      }

      function setActiveGoal(goal) {
        if (!goal) return;
        activeGoal = goal;

        desktopButtons.forEach(function (button) {
          var active = button.getAttribute('data-goal') === goal;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        accordionItems.forEach(function (item) {
          var active = item.getAttribute('data-goal') === goal;
          item.classList.toggle('is-open', active);
          var button = item.querySelector('.acd-acc-head');
          if (button) button.setAttribute('aria-expanded', active ? 'true' : 'false');
        });

        figures.forEach(function (figure) {
          var active = figure.getAttribute('data-goal-media') === goal;
          figure.hidden = !active;
          figure.classList.toggle('is-active', active);
          var video = figure.querySelector('video');
          if (video) syncPoster(video);
        });

        placeStage();
        pauseInactiveVideos();
        playActiveVideo();
      }

      desktopButtons.forEach(function (button) {
        ['mouseenter', 'focus', 'click'].forEach(function (eventName) {
          button.addEventListener(eventName, function () {
            setActiveGoal(button.getAttribute('data-goal'));
          });
        });
      });

      accordionItems.forEach(function (item) {
        var button = item.querySelector('.acd-acc-head');
        if (!button) return;
        button.addEventListener('click', function () {
          setActiveGoal(item.getAttribute('data-goal'));
        });
      });

      window.addEventListener('resize', function () {
        placeStage();
        figures.forEach(function (figure) {
          var video = figure.querySelector('video');
          if (video) syncPoster(video);
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          figures.forEach(function (figure) {
            var video = figure.querySelector('video');
            if (video) video.pause();
          });
        } else {
          playActiveVideo();
        }
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sectionVisible = entry.isIntersecting;
            if (sectionVisible) {
              playActiveVideo();
            } else {
              figures.forEach(function (figure) {
                var video = figure.querySelector('video');
                if (video) video.pause();
              });
            }
          });
        }, { rootMargin: '300px 0px', threshold: .01 });
        observer.observe(section);
      } else {
        sectionVisible = true;
      }

      setActiveGoal(activeGoal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAceiiTrainingGoals);
  } else {
    initAceiiTrainingGoals();
  }

  document.addEventListener('shopify:section:load', initAceiiTrainingGoals);
})();
